import request from '@/utils/request'

const getCurrentUserTrainings = () => {
  return request({
    url: `${process.env.VUE_APP_TIKTOK_API}/app/training-plan/current-user-trainings`,
    method: 'get'
  })
}

export default {
  getCurrentUserTrainings
}
